// export class BulkCreateQuestionBankItem {
//   className: string;
//   subjectName: string;
//   chapterName: string;
//   topicName?: string;
//   marks: number;
//   abilityName?: string;
//   abilityTypeName?: string;
//   difficultyName?: string;
//   questionTypeName?: string;
//   questionEn?: string;
//   questionHi?: string;
//   hasStimulus?: string;
//   estimatedTime?: number;
//   competencyCode?: string;
//   answerKey?: string;
//   preparedBy?: string;
//   mobileNo?: string;
//   remarks?: string;
//   questionPaperPrintedLanguage?: string;
// }

// export class BulkCreateQuestionBankReqModel {
//   questions: BulkCreateQuestionBankItem[];
//   userName: string;
// }



// In @boi/shared-models

// export class QuestionOptionModel {
//   optionNo: number;  // 1, 2, 3, 4
//   optionText: string;
// }

// export class BulkCreateQuestionBankItem {
//   department: string;
//   subjectName: string;
//   questionEn: string;        // Only question text (no HTML)
//   options?: QuestionOptionModel[];  // Array of options
//   answerKey: string;
//   difficultyName?: string;
//   source?: string;
//   preparedBy?: string;
//   mobileNo?: string;
//   createdBy?: string;
// }

// export class BulkCreateQuestionBankReqModel {
//   questions: BulkCreateQuestionBankItem[];
//   userName: string;
// }


export class QuestionOptionModel {
  optionNo: number;  // 1, 2, 3, 4
  optionText: string;
}

export class BulkCreateQuestionBankItem {
  department: string;
  subjectName: string;
  questionEn: string;        // Question text (encrypted)
  language: number;          // 2 = English, 3 = Telugu
  options?: QuestionOptionModel[];
  answerKey: string;
  difficultyName?: string;
  source?: string;
  preparedBy?: string;
  mobileNo?: string;
  createdBy?: string;
  teluguVersion?: BulkCreateQuestionBankItem | null; // For the same question in Telugu
}

export class BulkCreateQuestionBankReqModel {
  questions: (BulkCreateQuestionBankItem & { teluguVersion?: BulkCreateQuestionBankItem | null })[];
  userName: string;
}
